// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vuetify-like-phone-input[data-v-1859e3f4]{border:1px solid rgba(0,0,0,.38)!important;border-radius:4px;height:42px}.vuetify-like-phone-input[data-v-1859e3f4]:focus-within{border-color:#1976d2!important;border-width:2px!important}", ""]);
// Exports
module.exports = exports;
